// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/productivity-ot-data/ot-without-machine-operations",
  Create: "/pyr/productivity-ot-data/ot-without-machine-operations",
  Sync: "/pyr/productivity-ot-data/ot-without-machine-operations/sync",
};
